/**
 * Parses REACT_APP_ENFORCE_SECURITY_CODE.
 * @returns `true` / `false` when explicit; `null` when unset, empty, or non-boolean — caller falls back to Unleash.
 */
export const parseEnforceSecurityCodeEnv = (raw: string | undefined): boolean | null => {
  if (raw === undefined || raw === '') return null;
  const normalized = raw.trim().toLowerCase();
  if (normalized === 'true') return true;
  if (normalized === 'false') return false;
  return null;
};
